module.exports = __webpack_public_path__ + "static/media/fixly_logo.ecdfa02a.svg";